import React from "react";
import {
    Alert,
    Box,
    Button,
    Checkbox,
    FormControlLabel,
    Grid,
    MenuItem,
    Paper,
    Snackbar,
    TextField,
    Typography,
} from "@mui/material";
import axios from "axios";
import { useSelector } from "react-redux";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import RefreshIcon from '@mui/icons-material/Refresh';
import withLanguage from "../../HOC/withLanguage";
import withAuthChecker from "../../HOC/withAuthChecker";
import CustomTable from "./ArsimiDualComponents/CustomTable";

let pageSize = 5;

const DualApplication = ({ language }) => {
    const [submitting, setSubmitting] = React.useState(false);
    const [schoolOptions, setSchoolOptions] = React.useState([]);
    const [qualificationOptions, setQualificationOptions] = React.useState([]);
    const user = useSelector((state) => state.user);
    const [page, setPage] = React.useState(0);
    const defaultDa = () => ({
        nipt: "",
        companyName: "",
        phone: "",
        email: "",
        institutionId: "",
        qualificationId: "",
        numberOfJobPositions: "",
        declareCheckbox: false,
    });

    const [da, setDa] = React.useState(defaultDa());
    const [snackbar, setSnackbar] = React.useState({ open: false, message: "", severity: "success" });
    const closeSnackbar = () => setSnackbar((s) => ({ ...s, open: false }));
    const [showForm, setShowForm] = React.useState(false);
    const [accessMessage, setAccessMessage] = React.useState("");
    const [applications, setApplications] = React.useState(null);
    const [readOnlyForm, setReadOnlyForm] = React.useState(false);

    const columns = [
      {
        header: language?.da_institutionName,
        accessor: "institution_name",
        cellClassName:
          "border-b border-slate-100 px-4 py-4 text-sm font-medium text-slate-800",
      },
      {
        header: language?.da_qualificationName,
        accessor: "qualification_name",
        cellClassName:
          "border-b border-slate-100 px-4 py-4 text-sm text-slate-700",
      },
      {
        header: language?.da_jobPositionsNr,
        accessor: "number_of_job_positions",
        cellClassName:
          "border-b border-slate-100 px-4 py-4 text-sm text-slate-600",
      },
      {
        header: language?.da_applicationDate,
        accessor: "date_applied",
        isDate: true,
        cellClassName:
          "border-b border-slate-100 px-4 py-4 text-sm text-slate-600",
      },
      {
        header: "",
        headerClassName: "text-right",
        cellClassName: "border-b border-slate-100 px-4 py-4 text-right",
        render: (item) => (
          <button
            className="inline-flex border-0 bg-transparent text-[#dc2626]"
            onClick={() => showApplicationDetails(item)}
          >
            <ArrowForwardIcon />
          </button>
        ),
      },
    ];

    const [sa, setSa] = React.useState();
    const [isSchoolCoordinator, setIsSchoolCoordinator] = React.useState(false);
    const [applicationsBySchool, setApplicationsBySchool] = React.useState(null);
    const [schoolApplicationsPage, setSchoolApplicationsPage] = React.useState(0);
    const [schoolAppShowForm, setSchoolAppShowForm] = React.useState(false);


    React.useEffect(() => {
      axios
        .get("/api/data/institution?dual_education__exact=true", {
          headers: { API_KEY: "123456789" },
        })
        .then((res) => {
          setSchoolOptions(Array.isArray(res.data) ? res.data : []);
        })
        .catch(() => setSchoolOptions([]));
    }, []);


    React.useEffect(() => {
        if (!user) return;
        if (user.type && user.type.toLowerCase() === "organisation") {
            setDa((s) => ({
                ...s,
                nipt: s.nipt || user.nipt || "",
                companyName: s.companyName || user.name || "",
                phone: s.phone || user.mobile || "",
                email: s.email || user.email || "",
            }));
        }
    }, [user]);

    React.useEffect(() => {
        if(!da.institutionId) return
        axios.get(`/api/institution_configuration/degree?institution_id__exact=${da.institutionId}&dual_education__exact=true`, { 
            headers: { API_KEY: "123456789" },
        })
            .then((res) => {
                const data = res.data;
                if (Array.isArray(data)) {
                    setQualificationOptions(data);
                } else {
                    setQualificationOptions([]);
                }
            })
            .catch(() => {
                setQualificationOptions([]);
            });
    }, [da.institutionId])

    const daOnChange = (e) => {
        const { name, value, type, checked } = e.target;
        setDa((s) => ({
            ...s,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const onChangeSelectDa = (name, value) => {
        setDa((s) => {
            if (name === "institutionId") {
            if (s.institutionId === value) return s;

            return {
                ...s,
                institutionId: value,
                qualificationId: "",
            };
            }

            return { ...s, [name]: value };
        });
    };

    const getApplicationsData = () => {
      if(!user?.nipt) return
      axios.get(`/api/nipt_applications/${user?.nipt}?page=${page+1}&per_page=${pageSize}`, {
          headers: { "API_KEY": "123456789" },
      })
      .then((res) => {
          if(res?.data?.found) {
              setApplications(res?.data?.data)
          } 
      })
      .catch((err) => {
        setApplications(null)
      });
  }

  React.useEffect(() => {
      getApplicationsData()
  }, [user, page, pageSize])

  const handleChangePage = (event, newPage) => {
      setPage(newPage);
  };

    const onSubmit = (e) => {
        e.preventDefault();
        setSubmitting(true);

        const payload = {
            nipt: da.nipt || "",
            name: da.companyName || "",
            email: da.email || "",
            contact_number: da.phone || "",
            institution_id: da.institutionId || null,
            qualificationId: da.qualificationId || null,
            number_of_job_positions: da.numberOfJobPositions ? parseInt(da.numberOfJobPositions) : null,
            declare_checkbox: !!da.declareCheckbox,
        };

        if(!payload?.nipt || !payload?.name || !payload?.contact_number || !payload?.email || !payload?.institution_id || !payload?.qualificationId || !payload?.number_of_job_positions || !payload?.declare_checkbox ){
            setSnackbar({ open: true, message: language.loginAndFieldsRequired, severity: "error" });
            return
        }

        axios.post("/api/create_shprehje_interesi_subjekt", JSON.stringify(payload), {
            headers: { "API_KEY": "123456789", "Content-Type": "text/plain" },
        })
            .then((res) => {
                if(res?.status === 200){
                    setSnackbar({ open: true, message: language.submitSuccess, severity: "success" });
                    setDa((s) => ({
                        nipt: user?.nipt || "",
                        companyName: user?.name || "",
                        phone: user?.mobile || "",
                        email: user?.email || "",
                        institutionId: "",
                        qualificationId: "",
                        numberOfJobPositions: "",
                        declareCheckbox: false,
                    }));
                } else {
                    setSnackbar({ open: true, message: language.da_submitError, severity: "error" });
                }
                setSubmitting(false);
            })
            .catch((err) => {
                setDa((s) => ({
                        nipt: user?.nipt || "",
                        companyName: user?.name || "",
                        phone: user?.mobile || "",
                        email: user?.email || "",
                        institutionId: "",
                        qualificationId: "",
                        numberOfJobPositions: "",
                        declareCheckbox: false,
                    }));
                const message =
                    err.response?.data?.message || 
                    language.da_submitError
                setSnackbar({ open: true, message: message, severity: "error" });
                setSubmitting(false);
            });
    };

    const showApplicationDetails = (subject) => {
        setReadOnlyForm(true);
        setShowForm(true);

        setDa((s) => ({
            ...s,
            institutionId: subject?.institution_id || null,
            qualificationId: subject?.qualification_id || null,
            numberOfJobPositions: subject?.number_of_job_positions ? parseInt(subject?.number_of_job_positions) : null,
            declareCheckbox: subject?.declare_checkbox
        }));
    };

    const handleApply = () => {
      if (user?.type?.toLowerCase() === "organisation") {
          setReadOnlyForm(false);
          setDa((s) => ({
            nipt: s.nipt || user.nipt || "",
            companyName: s.companyName || user.name || "",
            phone: s.phone || user.mobile || "",
            email: s.email || user.email || "",
            institutionId: "",
            qualificationId: "",
            numberOfJobPositions: "",
            declareCheckbox: false,
          }));
          setAccessMessage("");
          setShowForm(true);
      } else {
        
            (user?.type?.toLowerCase() === "individual") ? setAccessMessage(language?.da_indAccessDenied) : setAccessMessage(language?.da_businessRequired);
          
          setShowForm(false);
      }
  
    }

  //Applications by School

    const columnsSchoolApplications = [
      {
        header: language?.da_nipt,
        accessor: "nipt",
        cellClassName:
          "border-b border-slate-100 px-4 py-4 text-sm font-medium text-slate-800",
      },
      {
        header: language?.da_name,
        accessor: "name",
        cellClassName:
          "border-b border-slate-100 px-4 py-4 text-sm font-medium text-slate-800",
      },
      {
        header: language?.da_email,
        accessor: "email",
        cellClassName:
          "border-b border-slate-100 px-4 py-4 text-sm text-slate-700",
      },
      {
        header: language?.da_contactNumber,
        accessor: "contact_number",
        cellClassName:
          "border-b border-slate-100 px-4 py-4 text-sm text-slate-600",
      },
      {
        header: language?.da_jobPositionsNr,
        accessor: "number_of_job_positions",
        cellClassName:
          "border-b border-slate-100 px-4 py-4 text-sm text-slate-600",
      },
      {
        header: language?.da_qualification,
        accessor: "qualification_id",
        isObject:true,
        cellClassName:
          "border-b border-slate-100 px-4 py-4 text-sm text-slate-600",
      },
      {
        header: "",
        headerClassName: "text-right",
        cellClassName: "border-b border-slate-100 px-4 py-4 text-right",
        render: (item) => (
          <button
            className="inline-flex border-0 bg-transparent text-[#dc2626]"
            onClick={() => showSchoolApplicationDetails(item)}
          >
            <ArrowForwardIcon />
          </button>
        ),
      },
    ];

  const getSubjectsData = () => {
    if(!user?.nid) return
      axios.get(`/api/person_search/${user?.nid}?page=1&per_page=1`, {
          headers: { "API_KEY": "123456789" },
      })
      .then((res) => {
        setIsSchoolCoordinator(res?.data?.found)
        if(res?.data?.institution_id){
          getApplicationsBySchool(res?.data?.institution_id)
        }
      })
      .catch((err) => {});
  }

    React.useEffect(() => {
        getSubjectsData()
    }, [user])

  const getApplicationsBySchool = (schoolId) => {
      if(!schoolId) return
      axios.get(`/api/data/shprehje_interesi_subjekt/${schoolId}?page=${schoolApplicationsPage+1}&per_page=${pageSize}`, {
          headers: { "API_KEY": "123456789" },
      })
      .then((res) => {
          if(res) {
            setApplicationsBySchool(res?.data)
          } 
      })
      .catch((err) => {
        
      });
  }

  const handleSchoolAppChangePage = (event, newPage) => {
      setSchoolApplicationsPage(Number(newPage));
  };

  const showSchoolApplicationDetails = (subject) => {
    setSa({
        name: subject?.name || "",
        nipt: subject?.nipt || "",
        email: subject?.email || "",
        contactNumber: subject?.contact_number || "",
        numberOfJobPositions: subject?.number_of_job_positions || "",
        declareCheckbox: subject?.declare_checkbox || "",
        institutionName: subject?.institution_id?.name || "",
        qualificationName: subject?.qualification_id?.name || "",
    });
    setSchoolAppShowForm(true);
  };

    return (
      <section className="flex flex-1 items-center">
        {/* UI for Organizations */}
        {!isSchoolCoordinator && (
          <Box
            component="form"
            onSubmit={onSubmit}
            sx={{ display: "grid", gap: 2, width: "100%" }}
          >
            <Paper elevation={0} sx={{ width: "100%" }}>
              {!showForm ? (
                <Grid
                  sx={{
                    position: "relative",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    py: 6,
                  }}
                >
                  {applications?.records?.length > 0 && (
                    <>
                      <button
                        type="button"
                        className="inline-flex border-0 bg-transparent text-[#dc2626] absolute top-20 right-9"
                        onClick={() => {
                          setPage(0);
                          getApplicationsData();
                        }}
                      >
                        <RefreshIcon />
                      </button>
                      <CustomTable
                        title={`${language?.da_applications}:`}
                        data={applications?.records || []}
                        columns={columns}
                        pagination={{
                          count: applications?.amount,
                          pageSize,
                          page,
                          onPageChange: handleChangePage,
                        }}
                        emptyMessage={language.da_emptyMessage}
                      />
                    </>
                  )}
                  <Grid item xs={12}>
                    <Typography
                      variant="h6"
                      sx={{
                        mb: 2,
                        fontWeight: 700,
                        fontSize: "1.8rem",
                        maxWidth: "70%",
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                    >
                      {language?.da_middleSubtitle}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      sx={{
                        textTransform: "none",
                        borderWidth: 2,
                        borderRadius: "1.5rem",
                        padding: "0.4rem 1rem",
                        borderColor: "#e5e7eb",
                        color: "#fff",
                        fontWeight: "bold",
                        backgroundColor: "#dc2626",
                        fontSize: "1rem",
                        "&:hover": {
                          backgroundColor: "#dc2626",
                          borderColor: "#b91c1c",
                        },
                      }}
                      onClick={() => handleApply()}
                    >
                      {language?.da_openButtonText}
                    </Button>
                  </Grid>
                  {accessMessage && (
                    <Grid item xs="auto">
                      <Typography
                        sx={{
                          display: "inline-block",
                          color: "#dc2626",
                          fontWeight: 600,
                          backgroundColor: "#fee2e2",
                          padding: "0.5rem 1rem",
                          borderRadius: "0.75rem",
                          border: "1px solid #fecaca",
                          fontSize: "0.95rem",
                          mt: 3.5,
                        }}
                      >
                        {accessMessage}
                      </Typography>
                    </Grid>
                  )}
                </Grid>
              ) : (
                <>
                  <Button
                    type="button"
                    variant="outlined"
                    sx={{
                      textTransform: "none",
                      marginBottom: "2rem",
                      fontWeight: "bold",
                      borderColor: "transparent",
                      color: "#dc2626",
                      backgroundColor: "transparent",
                      fontSize: "1rem",
                      "&:hover": {
                        backgroundColor: "transparent",
                        borderColor: "transparent",
                      },
                    }}
                    onClick={() => {
                      getApplicationsData();
                      setShowForm(false);
                    }}
                  >
                    <ArrowBackIcon className="mr-5" />
                    {language?.backToApplicationsList}
                  </Button>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 700, mb: 1 }}
                  >
                    {language.da_title}
                  </Typography>

                  <Typography
                    variant="subtitle2"
                    sx={{ fontWeight: 600, mb: 1 }}
                  >
                    {language.da_sectionA}
                  </Typography>

                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        sx={{
                          "& .MuiOutlinedInput-root": { borderRadius: "15px" },
                        }}
                        label={language.da_nipt}
                        name="nipt"
                        value={da.nipt}
                        onChange={daOnChange}
                        fullWidth
                        required
                        disabled
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        sx={{
                          "& .MuiOutlinedInput-root": { borderRadius: "15px" },
                        }}
                        label={language.da_companyName}
                        name="companyName"
                        value={da.companyName}
                        onChange={daOnChange}
                        fullWidth
                        required
                        disabled
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        sx={{
                          "& .MuiOutlinedInput-root": { borderRadius: "15px" },
                        }}
                        label={language.da_phone}
                        name="phone"
                        type="tel"
                        value={da.phone}
                        onChange={daOnChange}
                        fullWidth
                        required
                        disabled
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        sx={{
                          "& .MuiOutlinedInput-root": { borderRadius: "15px" },
                        }}
                        label={language.da_email}
                        name="email"
                        type="email"
                        value={da.email}
                        onChange={daOnChange}
                        fullWidth
                        required
                        disabled
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        sx={{
                          "& .MuiOutlinedInput-root": { borderRadius: "15px" },
                        }}
                        select
                        label={language.da_school}
                        value={da.institutionId}
                        onChange={(e) =>
                          onChangeSelectDa("institutionId", e.target.value)
                        }
                        fullWidth
                        required
                        disabled={readOnlyForm}
                      >
                        {schoolOptions.map((s) => (
                          <MenuItem
                            key={s.id ?? s.ID ?? s.value}
                            value={s.id ?? s.ID ?? s.value}
                          >
                            {s.name ?? s.emri ?? s.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>

                    {/* Qualification */}
                    <Grid item xs={12} md={6}>
                      <TextField
                        sx={{
                          "& .MuiOutlinedInput-root": { borderRadius: "15px" },
                        }}
                        select
                        label={language.sa_qualification}
                        value={da.qualificationId}
                        onChange={(e) =>
                          onChangeSelectDa("qualificationId", e.target.value)
                        }
                        fullWidth
                        required
                        disabled={!da.institutionId || readOnlyForm}
                      >
                        {qualificationOptions?.map((q) => (
                          <MenuItem
                            key={q.id ?? q.ID ?? q.value}
                            value={q.id ?? q.ID ?? q.value}
                          >
                            {q.name ?? q.emri ?? q.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        sx={{
                          "& .MuiOutlinedInput-root": { borderRadius: "15px" },
                        }}
                        label={language.da_jobPositionsNr}
                        name="numberOfJobPositions"
                        type="number"
                        value={da.numberOfJobPositions}
                        onChange={daOnChange}
                        fullWidth
                        required
                        inputProps={{ min: 0 }}
                        disabled={readOnlyForm}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="declareCheckbox"
                            checked={da.declareCheckbox}
                            onChange={daOnChange}
                            required
                            sx={{ "&.Mui-checked": { color: "#dc2626" } }}
                            disabled={readOnlyForm}
                          />
                        }
                        label={language.da_checkbox}
                      />
                    </Grid>
                  </Grid>
                </>
              )}
            </Paper>

            {showForm && (
              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                  type="submit"
                  variant="contained"
                  size="large"
                  disabled={readOnlyForm || submitting}
                  sx={{
                    textTransform: "none",
                    borderWidth: 2,
                    borderRadius: "1.5rem",
                    padding: "0.5rem 1.4rem",
                    borderColor: "#e5e7eb",
                    color: "#fff",
                    fontWeight: "bold",
                    backgroundColor: "#dc2626",
                    "&:hover": {
                      backgroundColor: "#dc2626",
                      borderColor: "#b91c1c",
                    },
                  }}
                >
                  {language.submit}
                </Button>
              </Box>
            )}
          </Box>
        )}

        {/* UI for School Coordinators */}

        {isSchoolCoordinator && (
            <Paper  elevation={0} sx={{ width: "100%" }}>
              <Grid
                sx={{
                  position: "relative",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  py: 6,
                }}
              >
                {!schoolAppShowForm && <><button
                  type="button"
                  className="inline-flex border-0 bg-transparent text-[#dc2626] absolute top-20 right-9"
                  onClick={() => {
                    setSchoolApplicationsPage(0);
                    getApplicationsBySchool();
                  }}
                >
                  <RefreshIcon />
                </button>
                <CustomTable
                  title={`${language?.da_applications}:`}
                  data={applicationsBySchool?.records || []}
                  columns={columnsSchoolApplications}
                  pagination={{
                    count: applicationsBySchool?.amount,
                    pageSize,
                    page:schoolApplicationsPage,
                    onPageChange: handleSchoolAppChangePage,
                  }}
                  emptyMessage={language.da_emptyMessage}
                /></>}

                  {/* Application Details Form */}

                  {schoolAppShowForm && <div className="text-left">
                  <Button
                    type="button"
                    variant="outlined"
                    sx={{
                      textTransform: "none",
                      marginBottom: "2rem",
                      fontWeight: "bold",
                      borderColor: "transparent",
                      color: "#dc2626",
                      backgroundColor: "transparent",
                      fontSize: "1rem",
                      textAlign:'left',
                      "&:hover": {
                        backgroundColor: "transparent",
                        borderColor: "transparent",
                      },
                    }}
                    onClick={() => {
                      getApplicationsData();
                      setSchoolAppShowForm(false);
                    }}
                  >
                    <ArrowBackIcon className="mr-5" />
                    {language?.backToApplicationsList}
                  </Button>
                  <Box
                    component="form"
                    sx={{ display: "grid", gap: 2, width: "100%" }}
                  >
                    <Paper variant="outlined" sx={{ p: 2 }}>
                      <Typography
                        variant="subtitle1"
                        sx={{ fontWeight: 700, mb: 2, textAlign:'left' }}
                      >
                        {sa.name}
                      </Typography>

                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <TextField
                            sx={{
                              "& .MuiOutlinedInput-root": { borderRadius: "15px" },
                            }}
                            label={language.da_nipt}
                            name="nipt"
                            value={sa.nipt}
                            fullWidth
                            disabled
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            sx={{
                              "& .MuiOutlinedInput-root": { borderRadius: "15px" },
                            }}
                            label={language.da_companyName}
                            name="name"
                            value={sa.name}
                            fullWidth
                            disabled
                          />
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <TextField
                            sx={{
                              "& .MuiOutlinedInput-root": { borderRadius: "15px" },
                            }}
                            label={language.da_email}
                            name="email"
                            value={sa.email}
                            fullWidth
                            disabled
                          />
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <TextField
                            sx={{
                              "& .MuiOutlinedInput-root": { borderRadius: "15px" },
                            }}
                            label={language.da_contactNumber}
                            name="contactNumber"
                            value={sa.contactNumber}
                            fullWidth
                            disabled
                          />
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <TextField
                            sx={{
                              "& .MuiOutlinedInput-root": { borderRadius: "15px" },
                            }}
                            label={language.da_jobPositionsNr}
                            name="numberOfJobPositions"
                            type="number"
                            value={sa.numberOfJobPositions}
                            fullWidth
                            disabled
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            sx={{
                              "& .MuiOutlinedInput-root": { borderRadius: "15px" },
                            }}
                            label={language.da_schoolChoosed}
                            name="institutionName"
                            value={sa.institutionName}
                            fullWidth
                            disabled
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            sx={{
                              "& .MuiOutlinedInput-root": { borderRadius: "15px" },
                            }}
                            label={language.da_qualification}
                            name="qualificationName"
                            value={sa.qualificationName}
                            fullWidth
                            disabled
                          />
                        </Grid>

                        <Grid item xs={12}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                name="declareCheckbox"
                                checked={sa.declareCheckbox}
                                sx={{ "&.Mui-checked": { color: "#dc2626" } }}
                                disabled
                              />
                            }
                            label={language.da_checkbox}
                          />
                        </Grid>
                      </Grid>
                    </Paper>
                  </Box>
                </div>}

              </Grid>
            </Paper>
        )}

        <Snackbar
          open={snackbar.open}
          autoHideDuration={6000}
          onClose={closeSnackbar}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <Alert
            onClose={closeSnackbar}
            severity={snackbar.severity}
            sx={{ width: "100%" }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </section>
    );
};

export default withAuthChecker(withLanguage(DualApplication, "SubjectDeclaration"), 5);